module.exports = __webpack_public_path__ + "media/images/favicons/ms-icon-144x144-45dd69c6c321d8368686f3125830faf4.png";